import type { IssueKind, IssueSeverity, IssueStatus } from './PolicyIssues';

/** Status pill colors, sourced from theme tokens (never hardcoded hex). */
export const STATUS_META: Record<IssueStatus, { label: string; bg: string; fg: string; border: string }> = {
    open: { label: 'Open', bg: 'var(--bm-color-danger-soft)', fg: 'var(--bm-color-danger-text)', border: 'var(--bm-color-danger-border)' },
    investigating: { label: 'Investigating', bg: 'var(--bm-color-caution-soft)', fg: 'var(--bm-color-caution-text)', border: 'var(--bm-color-caution-border)' },
    resolved: { label: 'Resolved', bg: 'var(--bm-color-success-soft)', fg: 'var(--bm-color-success)', border: 'var(--bm-color-success-border)' },
};

export const SEVERITY_COLOR: Record<IssueSeverity, string> = { critical: 'red', high: 'orange', medium: 'yellow' };
export const SEVERITY_RANK: Record<IssueSeverity, number> = { critical: 3, high: 2, medium: 1 };

/** Source/kind chip metadata for the Issues tab and detail drawer. */
export const KIND_META: Record<IssueKind, { label: string; color: string }> = {
    policy: { label: 'Policy', color: 'grape' },
    sensitivity: { label: 'Sensitive Data', color: 'red' },
};

export const ALL_STATUSES: IssueStatus[] = ['open', 'investigating', 'resolved'];
